/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIContactGroupView } from './APIContactGroupView';
import {
    APIContactGroupViewFromJSON,
    APIContactGroupViewFromJSONTyped,
    APIContactGroupViewToJSON,
} from './APIContactGroupView';

/**
 * 
 * @export
 * @interface APIPaginatedContactGroupViewList
 */
export interface APIPaginatedContactGroupViewList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedContactGroupViewList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedContactGroupViewList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedContactGroupViewList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIContactGroupView>}
     * @memberof APIPaginatedContactGroupViewList
     */
    results: Array<APIContactGroupView>;
}

/**
 * Check if a given object implements the APIPaginatedContactGroupViewList interface.
 */
export function instanceOfAPIPaginatedContactGroupViewList(value: object): value is APIPaginatedContactGroupViewList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedContactGroupViewListFromJSON(json: any): APIPaginatedContactGroupViewList {
    return APIPaginatedContactGroupViewListFromJSONTyped(json, false);
}

export function APIPaginatedContactGroupViewListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedContactGroupViewList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIContactGroupViewFromJSON)),
    };
}

export function APIPaginatedContactGroupViewListToJSON(value?: APIPaginatedContactGroupViewList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIContactGroupViewToJSON)),
    };
}

